import React from "react";
import { FaLongArrowAltRight } from "react-icons/fa";
import WebsiteLogo from "../images/Logo.png";
import { IoMenu } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import type { MenuProps } from "antd";
import { Dropdown, Space } from "antd";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

//-----Use State Function for Gallery filter image and Gallery Category Heading-----------

type HeaderProps = {
  setFilterImg: React.Dispatch<React.SetStateAction<string>>; // function type from useState
  setgalleryHead: React.Dispatch<React.SetStateAction<string>>;
};
const Header = ({ setFilterImg, setgalleryHead }: HeaderProps) => {
  let menuOpen = false;

  //-----------Menu Links-----------

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Link
          to="/gallery"
          onClick={() => {
            setFilterImg("Barnyard Theme");
            setgalleryHead("Baby Boy");
            closeMenu(); // ✅ Close menu on click
          }}
        >
          Baby Boy
        </Link>
        // <a  rel="noopener noreferrer" href="/gallery" onClick={() => setFilterImg("Disco Theme")}>
        //   Baby Boy
        // </a>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          to="/gallery"
          onClick={() => {
            setFilterImg("Alice in Wonderland");
            setgalleryHead("Baby Girl");
            closeMenu(); // ✅ Close menu on click
          }}
        >
          Baby Girl
        </Link>
        // <a  rel="noopener noreferrer" href="/gallery" onClick={() => setFilterImg("Barnyard Theme")}>
        //   Baby Girl
        // </a>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          to="/gallery"
          onClick={() => {
            setFilterImg("Blush Fairyland Theme");
            setgalleryHead("Baby Shower");
            closeMenu(); // ✅ Close menu on click
          }}
        >
          Baby Shower
        </Link>
        // <a  rel="noopener noreferrer" href="/gallery" onClick={() => setFilterImg("Backdrop Options")}>
        //   Baby Shower
        // </a>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          to="/gallery"
          onClick={() => {
            setFilterImg("Space Theme");
            setgalleryHead("Bridal Shower");
            closeMenu(); // ✅ Close menu on click
          }}
        >
          Bridal Shower
        </Link>
        // <a  rel="noopener noreferrer" href="/gallery" onClick={() => setFilterImg("Barnyard Theme")}>
        //   Bridal Shower
        // </a>
      ),
    },
    {
      key: "5",
      label: (
        <Link
          to="/gallery"
          onClick={() => {
            setFilterImg("Backdrop Options");
            setgalleryHead("Adult Celebration");
            closeMenu(); // ✅ Close menu on click
          }}
        >
          Adult Celebration
        </Link>
        // <a  rel="noopener noreferrer" href="/gallery" onClick={() => setFilterImg("Backdrop Options")}>
        //   Adult Celebration
        // </a>
      ),
    },
  ];

  // ---------------Menu Icon Open and Close ---------------
  function initVanillaJS() {
    const menuIcon = document.querySelector(".menu__icon");
    const navLinks = document.querySelector(".menu__linkItems") as HTMLElement;

    if (!menuIcon || !navLinks) return;

    menuIcon.addEventListener("click", () => {
      if (menuOpen === false) {
        navLinks.style.display = "flex";
        menuOpen = true;
      } else {
        navLinks.style.display = "none";
        menuOpen = false;
      }
    });
  }
  setTimeout(() => {
    initVanillaJS();
  }, 0);

  function closeMenu() {
    const navLinks = document.querySelector(".menu__linkItems") as HTMLElement;
    if (navLinks) {
      navLinks.style.display = "none";
      menuOpen = false;
    }
  }
  return (
    <section className="menu">
      <div className="container">
        <div className="menu__logo">
          <a href="/">
            <img src={WebsiteLogo} alt="" />
          </a>
        </div>
        <div className="menu__links split">
          <button className="menu__icon">
            <IoMenu />
          </button>
          <div className="menu__linkItems">
            <ul>
              <li>
                <Link to="/" onClick={closeMenu}>
                  Home
                </Link>
                {/* <IoIosArrowDown /> */}
              </li>
              <li>
                <HashLink smooth to="/#section2_about" onClick={closeMenu}>
                  About Us
                </HashLink>
              </li>
              <li>
                <Link to="/blog" onClick={closeMenu}>
                  Blog
                </Link>
                {/* <IoIosArrowDown /> */}
              </li>
              <li>
                <Dropdown menu={{ items }}>
                  <Link to="/gallery" onClick={(e) => e.preventDefault()}>
                    <Space>
                      Gallery
                      <IoIosArrowDown />
                    </Space>
                  </Link>
                </Dropdown>
              </li>
              <li>
                <Link to="/contact" onClick={closeMenu}>
                  Contact Us
                </Link>
                {/* <IoIosArrowDown /> */}
              </li>
            </ul>
          </div>
        </div>
        <Link to="/contact" onClick={closeMenu} className="primary-btn">
          <span className="link-span">
            <span className="arrow__icon">
              <FaLongArrowAltRight />
            </span>
            <span>Booking Now</span>
          </span>
        </Link>
      </div>
    </section>
  );
};

export default Header;
